import React from 'react'
import { Grid } from '@mui/material'
import CurrentPlan from '../components/plan-details/current-plan'
import ReasonPanel from '../components/reason-panel'
import StepHeader from '../components/step-header'
import makeStyles from '@mui/styles/makeStyles'
import StepPageContainer from '../components/step-page-container'

export const useStyles = makeStyles(({ breakpoints }) => ({
  leftPanel: {
    order: 1,
    [breakpoints.down('sm')]: {
      order: 2
    }
  },
  rightPanel: {
    order: 2,
    [breakpoints.down('sm')]: {
      order: 1
    }
  }
}))

const FeedbackPage = ({ reason, comment, setComment, onReasonChange }) => {
  const classes = useStyles()
  return (
    <StepPageContainer>
      <Grid item xs={12}>
        <StepHeader />
      </Grid>
      <Grid item xs={12} sm={12} md={6} className={classes.leftPanel}>
        <ReasonPanel value={reason} comment={comment} setComment={setComment} onChange={onReasonChange} />
      </Grid>
      <Grid item xs={12} sm={12} md={6} className={classes.rightPanel}>
        <CurrentPlan />
      </Grid>
    </StepPageContainer>
  )
}

export default FeedbackPage
